module.exports = __webpack_public_path__ + "static/media/9.2a849234.jpg";